import React, { RefObject, useEffect, useState, useContext } from "react";
import {
  PaymentContext,
  PaymentContextValue,
} from "../contexts/Payment/payment.context";

export default function PinInput({
  onChange,
  length = 4,
  hidden = false,
  autoFocus = false,
}) {
  const [value, setValue] = useState("");
  const { state }: PaymentContextValue = useContext(PaymentContext);
  const { checkoutSettings } = state.business || {};

  const refs: RefObject<HTMLInputElement | null>[] = Array.from(
    Array(length)
  ).map((_) => React.createRef());

  const handleChange = async (index, e: any) => {
    if (isNaN(Number(e.target.value))) {
      return;
    }

    const newValue = String(value) + Number(e.target.value);

    if (e.target.value) {
      setValue(newValue);

      if (newValue.length <= length - 1) {
        refs[newValue.length].current.focus();
      } else {
        refs[index].current.blur();
        if (typeof onChange === "function") {
          const reset = await onChange(newValue);
          reset && setValue("");
        }
      }
    } else {
      setValue(value.slice(0, index));
    }
  };

  const handleKeyDown = (index, e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Backspace" && !value[index]) {
      refs[index > 0 ? index - 1 : 0].current.focus();
    }
  };

  useEffect(() => {
    if (autoFocus) {
      refs[0].current?.focus();
    }
  }, []);

  return (
    <div className={"flex sm:space-x-3"}>
      {Array.from(Array(length)).map((_, index) => (
        <input
          key={index}
          // @ts-ignore
          ref={refs[index]}
          type={hidden ? "password" : "text"}
          className={
            "appearance-none border rounded-lg border-gray-300 p-4 sm:scale-100 scale-75 w-14 h-14 text-center text-lg pb-3 outline-primary"
          }
          style={{
            borderColor: `${checkoutSettings?.fontColor}7F`,
            color: checkoutSettings?.fontColor,
            outlineColor: checkoutSettings?.fontColor,
          }}
          value={value.split("")[index] || ""}
          maxLength={1}
          onChange={(e) => handleChange(index, e)}
          onKeyDown={(e) => handleKeyDown(index, e)}
        />
      ))}
    </div>
  );
}
